import React from 'react';

interface InferredIngredientBadgeProps {
  isInferred: boolean;
}

export function InferredIngredientBadge({ isInferred }: InferredIngredientBadgeProps) {
  if (!isInferred) return null;

  return (
    <span className="inline-flex items-center px-1.5 py-0.5 text-[10px] font-medium text-blue-700 bg-blue-100 rounded-sm">
      <svg
        className="w-2.5 h-2.5 mr-0.5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
        />
      </svg>
      AI-suggested
    </span>
  );
}
